import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux'
import axios from 'axios'
import { FormattedMessage  } from 'react-intl';

import LoadingControl from './Loading';
import { PRINTERS_PATH, USERS_PATH, USERS_GROUPS_PATH, COMPUTERS_PATH, DOCUMENTS_PATH } from '../utils/constants';
import { getCurrencySymbol, formatBytes } from '../utils/utils';
import {ApplyFilterParams} from '../utils/ApplyFilterParams'
import DescriptionObject from './DescriptionObject';
import DocumentsTable from './DocumentsTable';
import ChartDistribution from './ChartDistribution';
import { GetMostActiveColumns } from './GetMostActiveObjectsColumn';
import MostActiveObjectsTable from './MostActiveObjectsTable';

const UserGroupReportGeneral = (props) => {
    const [state, setState] = useState({
        error: null,
        isLoaded: false,
        group: null
    });

    let filterData = useSelector(state => state.reportFilter);

    async function getData() {

        var url = ApplyFilterParams("/group/" + props.groupId + "?doNotReturnEmptyObjects=false", filterData);
        
        const res = await axios(url);
        return res.data;
        }

    useEffect(() => {
        if (props.groupId)
        {
            setState( {error: {message : "Bad group id"}});
        }
        setState({isLoaded: false});
    
        getData()
        .then(res => {
            setState({ error: null, isLoaded: true, group: getColumns(res) });
        })
        .catch(err => {
            setState( {error: err, isLoaded: false, group: null });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.groupId, filterData]);    


    let daysNumber = useRef();

    function getColumns(res)
    {
        const lang = navigator.language || navigator.userLanguage;

        var data = [];
        if ((res instanceof Array) && res.length > 0)
        {
            data = data = res[0];
        }

        let dateMin = new Date(data.minDate);
        let dateMax = new Date(data.maxDate);

        let reportPeriod = "";
        if (isNaN(dateMin) || isNaN(dateMax))
        {
            daysNumber.current = null;
        }
        else
        {
            daysNumber.current = Math.round(dateMax.getTime() - dateMin.getTime()) / (1000 * 60 * 60 * 24);

            reportPeriod = dateMin.toLocaleDateString(lang) + ' - ' + 
                    dateMax.toLocaleDateString(lang);

        }

        const formatConfig = {
            style: 'currency',
            currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
            minimumFractionDigits: 2,
            currencyDisplay: 'symbol',
        };

        const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

        var columns = [
            {
                title :  <FormattedMessage id="DeviceMetersTable.name"/>,
                data : data.groupName,
            },
            {
                title : <FormattedMessage id="Users"/>,
                data : data.users,
                link: USERS_PATH + "?groupId=" + props.groupId,
            },
            {
                title : <FormattedMessage id="Printers"/>,
                data : data.printers,
                link: PRINTERS_PATH + "?groupId=" + props.groupId,
            },
            {
                title : <FormattedMessage id="Computers"/>,
                data : data.computers,
                link: COMPUTERS_PATH + "?groupId=" + props.groupId,
            },
            {
                title : <FormattedMessage id="Report.PrintedJobs"/>,
                data : data.documents,
                link: DOCUMENTS_PATH + "?groupId=" + props.groupId,
            },
            {
                title : <FormattedMessage id="Pages"/>,
                data : data.pages,
            },
            {
                title : <FormattedMessage id="Cost"/>,
                data : currencyFormatter.format(data.cost === undefined ? 0 : data.cost),
            },
            {
                title : <FormattedMessage id="JobDataSize"/>,
                data : formatBytes(data.jobDataSize === undefined ? 0 : data.jobDataSize),
            },
            {
                title : <FormattedMessage id="ReportPeriod"/>,
                data : reportPeriod,
            },
        ];

        return columns;
    }


        if(state.error != null)
        {
            return (
                <div>
                    <h3>{state.error.message}</h3>
                    <Link to={USERS_GROUPS_PATH}><FormattedMessage id="Back"/></Link>
                </div>
            );
        }
        else if (!state.isLoaded)
        {
            return (
                <div><LoadingControl/></div>
            );
        }
        else
        {          
            if (state.group === null)
            {
                return ( 
                    <div>
                        <FormattedMessage id="ObjectNotFound"/>
                        <Link to={USERS_GROUPS_PATH}><FormattedMessage id="Back"/></Link>
                    </div>
                );
            }
            
            return (
            <div>
                <div className = "description-parent">
                    <div className = "description-object"><DescriptionObject object = {state.group}/></div>
                    <div className = "description-object"><ChartDistribution object_id = {'groupId=' + props.groupId}/></div>
                </div>
                <br/>
                <br/>
                <h4><FormattedMessage id="LastDocuments"/></h4>
                <DocumentsTable parent_id_param = {'?groupId=' + props.groupId} 
                                api_url = {ApplyFilterParams('job?maxCount=20&groupId=' + props.groupId, props.filterData)}/>
                <h4><FormattedMessage id="MostActiveUsers"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?groupId=' + props.groupId} 
                    api_url = {ApplyFilterParams('user?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&groupId=' + props.groupId, filterData)}
                    days_number = {daysNumber.current}
                    get_columns = {GetMostActiveColumns(USERS_PATH, '?groupId=' + props.groupId, daysNumber.current)}
                />
                <h4><FormattedMessage id="MostActivePrinters"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?groupId=' + props.groupId} 
                    api_url = {ApplyFilterParams('printer_ex?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&groupId=' + props.groupId, filterData)}
                    get_columns = {GetMostActiveColumns(PRINTERS_PATH, '?groupId=' + props.groupId, daysNumber.current)}

                />
                <h4><FormattedMessage id="MostActiveComputers"/></h4>
                <MostActiveObjectsTable 
                    parent_id_param = {'?groupId=' + props.groupId} 
                    api_url = {ApplyFilterParams('computer?noStats=false&returnEmpty=false&sort=Documents%20DESC&maxCount=10&groupId=' + props.groupId, filterData)}
                    days_number = {daysNumber.current}
                    get_columns = {GetMostActiveColumns(COMPUTERS_PATH, '?groupId=' + props.groupId, daysNumber.current)}
                />
            </div>
            )
        }    
}

export default UserGroupReportGeneral;